<div class="selector-container" [class.disabled]="disabled">
  <div
    class="selector-display"
    [class.open]="isOpen"
    (click)="toggleDropdown($event)"
  >
    <span>{{ value?.label || placeholder }}</span>
    <div class="arrow" [class.open]="isOpen">
      <mat-icon> chevron_right </mat-icon>
    </div>
  </div>
  <div class="dropdown" *ngIf="isOpen">
    <div *ngIf="allowSearch" class="search-box">
      <input type="text" placeholder="Buscar..." (input)="onSearch($event)" />
    </div>
    <ul class="options-list">
      <li *ngFor="let option of filteredOptions" (click)="selectOption(option)">
        {{ option.label }}
      </li>
      <li *ngIf="filteredOptions.length === 0" class="no-options">
        No options found
      </li>
    </ul>
  </div>
</div>
